import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { useTranslation } from 'react-i18next'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import styles from './validDeletePlaceDialog.module.scss'
import { useMutation } from '@apollo/client'
import { DELETE_PLACE } from '@/modules/API/daycare/daycareHandler'
import { Close, Delete } from '@mui/icons-material'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ValidDeletePlaceProps {
    open: boolean
    handleClose: () => void
    placeId: number
    daycareId: number
    removeOnePlace: (placeId: number) => void
}

const ValidDeletePlaceDialog: FunctionComponent<ValidDeletePlaceProps> = ({
    open,
    handleClose,
    placeId,
    daycareId,
    removeOnePlace
}: ValidDeletePlaceProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteOnePlace] = useMutation(DELETE_PLACE, {
        variables: {
            placeId: Number(placeId),
            daycareId: daycareId
        },
        onCompleted: () => {
            showNotificationSuccess(t('placeDeleted'))

            removeOnePlace(placeId)

            handleClose()
        },
        onError: () => {
            showNotificationError(t('errorDeletedPlace'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('confirmDeletePlace')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('confirmDeletePlaceMessage')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customIcon={<Delete />}
                        customText={t('yes')}
                        onClick={deleteOnePlace}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customIcon={<Close />}
                        customText={t('no')}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ValidDeletePlaceDialog
